import { useIntl, useSettings } from '@capsicum/common';
import { useUkAwareText } from '@capsicum/socios-core';
import { useSetAtom } from 'jotai';
import { useCallback, useMemo } from 'react';

import { FTOHowToDrawerAtom } from '../data-access';

export const useFanTokenOfferingHowToDrawer = () => {
	const { $t } = useIntl();
	const setFTOHowToDrawerSeen = useSetAtom(FTOHowToDrawerAtom);
	const {
		settings: { fanTokenOfferingTermsLinkUK, ftoWaveInfo }
	} = useSettings();
	const { isUkUser, selectUkAwareText } = useUkAwareText();

	const buttonText = $t('fanTokenOffering.howToDrawer.ukButton');
	const footerText = selectUkAwareText(
		$t('fanTokenOffering.howToDrawer.footer'),
		$t('fanTokenOffering.howToDrawer.ukFooter')
	);
	const secondaryActionButtonText = useMemo(
		() => (isUkUser ? $t('fanTokenOffering.howToDrawer.ukButtonText') : undefined),
		[isUkUser]
	);
	const howToDrawerTexts = {
		modalInfo: $t('fanTokenOffering.howToDrawer.info'),
		modalTitle: $t('fanTokenOffering.howToDrawer.title'),
		waveTableNoLimit: $t('fanTokenOffering.howToDrawer.table.noLimit'),
		waveTableTitle: $t('fanTokenOffering.howToDrawer.table.title'),
		waveTableWave: $t('fanTokenOffering.howToDrawer.table.wave')
	};

	const showWaveInfo = ftoWaveInfo?.length > 0;

	const markAsSeenForId = useCallback(
		(fanTokenOfferingId: string) => {
			setFTOHowToDrawerSeen((prev: Array<string>) => {
				if (prev.includes(fanTokenOfferingId)) {
					return prev;
				}

				return [...prev, fanTokenOfferingId];
			});
		},
		[setFTOHowToDrawerSeen]
	);

	return {
		buttonText,
		fanTokenOfferingTermsLinkUK,
		footerText,
		ftoWaveInfo,
		howToDrawerTexts,
		markAsSeenForId,
		secondaryActionButtonText,
		showWaveInfo
	};
};
